import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { MuiTextField, MuiButton, LoaderDots } from '../../../../../components'
import questionManagement from '../../../../../services/questionManagement.service'
import { useGlobalStore } from '../../../../../store'
import { OuterWrapper } from './style'
import { consoleLog } from '../../../../../util'

const Add = ({ onChange, settings }) => {
  const { company } = useGlobalStore()
  const initialFormObj = {
    itemQuestion: ''
  }

  const form = useRef()
  const [formData, setFormData] = useState(initialFormObj)
  const [loading, setLoading] = useState(false)

  const onChangeHandler = (value) => {
    setFormData({ itemQuestion: value })
  }

  const submitPayload = async (e) => {
    e.preventDefault()

    setLoading(true)
    const payload = { organizationId: company?.OrganizationId, [settings.keyValue]: formData?.itemQuestion, delete: false }
    // consoleLog('payload ------- ', payload)
    questionManagement.setOrganizationAggregationQuestionApi(payload, settings.type)
      .then((resp) => {
        // consoleLog('Add page > resp - ', resp)
      })
      .catch((error) => {
        consoleLog('ERROR - ', error)
      })
      .finally(() => {
        setLoading(false)
        setFormData(initialFormObj)
        onChange()
      })
  }

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload} autoComplete='on'>
        <Grid container spacing={2}>
          <Grid item xs={12} className='innerWrapper'>
            <MuiTextField
              name='itemQuestion'
              // placeholder={`Item Question ${settings.type.replace('question', '')}`}
              placeholder='Add Question'
              onChange={(e) => onChangeHandler(e.target.value)}
              variant='standard'
              value={formData?.itemQuestion || ''}
            />
            {/* <LoaderDots size='sm' /> */}
            {
              loading
                ? <LoaderDots size='sm' />
                : <MuiButton
                  onClick={submitPayload}
                  type='submit'
                  color='primary'
                  variant='contained'
                  disabled={formData?.itemQuestion === ''}
                >+</MuiButton>
            }
          </Grid>
        </Grid>
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func,
  settings: PropTypes.object
}

export default Add
